import React from 'react';
import { connect } from 'react-redux';
import { setEditorZoom } from '../actions';
import WidgetEmbed from './WidgetEmbed';
import Controls from './controls/Controls';
import Header from './controls/Header';

import ZoomControls from './controls/ZoomControls';
import _ from 'lodash';
var hash = require('object-hash');
const WidgetEmbedFromEdior = connect(({ editor }) => {
    const template = _.get(editor, 'widgetProps.template', editor.template); // get template

    const propsToOpen = editor.widgetProps;

    return {
        widgetId: editor.widgetId,
        widgetProps: { ...propsToOpen, editMode: true, template },
        zoom: editor.zoom,
        autozoom: editor.autozoom,
    };
})(WidgetEmbed);

const RenderError = ({ previewError }) =>
    previewError && previewError.message ? (
        <div
            style={{
                position: 'absolute',
                top: '30%',
                left: '50%',
                color: '#fff',
                zIndex: 100,
                padding: '20px 40px',
                borderRadius: 5,
                background: 'rgba(0,0,0,0.5)',
                transform: 'translate(-50%,-50%)',
            }}
        >
            <p>{_.capitalize(previewError.message)}</p>
            <p>Please select data in &quot;Data&quot; tab </p>
        </div>
    ) : null;

const styles = {
    scrollContainer: {
        flexGrow: 1,
        alignItems: 'center',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',

        position: 'relative',
        width: '100%',
    },
};

class PreviewAutoZoom extends React.Component {
    constructor() {
        super();
        this._debounceHandleScreenSizeUpdate = _.debounce(() => {
            this.forceUpdate();
        }, 100);
    }

    state = {
        displayValid: false,
    };

    static defaultProps = {};

    componentDidMount() {
        window.addEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
        this.interval = setInterval(() => {
            this.doCheck();
        }, 400);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._debounceHandleScreenSizeUpdate, false);
        if (this.interval) clearInterval(this.interval);
    }

    doCheck() {
        this.containerSize = this.container && {
            height: this.container.offsetHeight,
            width: this.container.offsetWidth,
        };
        if (!this.containerSize) {
            this.setState({
                displayValid: false,
            });
        }
        //console.log("!! displayValid ", this.state.displayValid)

        if (this.containerSize && this.widgetSize && this.widgetSize.height > 0 && this.props.autozoom) {
            const GAP = 15;
            const wZoom = (this.containerSize.width - 2 * GAP) / this.widgetSize.width;
            const hZoom = (this.containerSize.height - 2 * GAP) / this.widgetSize.height;

            let zoom = +Math.min(Math.floor(wZoom * 10) / 10, Math.floor(hZoom * 10) / 10, 1.0).toFixed(1);

            zoom = Math.floor(zoom * 10) / 10;

            if (!this.state.displayValid || (this.props.zoom != zoom && zoom <= 1.0)) {
                this.props.setEditorZoom(zoom, zoom > 50);
                this.setState({
                    displayValid: true,
                });
            }
        }
    }

    render() {
        const { preview, previewError, text, label, mainAction, zoom } = this.props;
        console.log('GERE');
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    overflow: 'hidden',
                    position: 'relative',
                    width: '100%',
                }}
            >
                <Header label={label} text={text} />
                <RenderError previewError={previewError} />
                <div
                    ref={r => {
                        this.container = r;
                    }}
                    style={{
                        ...styles.scrollContainer,
                        ...{
                            filter: preview ? '' : 'blur(4px)',
                            // opacity: this.state.displayValid ? '1' : '0.01',
                        },
                    }}
                >
                    <WidgetEmbedFromEdior
                        onMeasure={({ width, height }) => {
                            console.log('ON MEASURE');
                            if (
                                !this.widgetSize ||
                                Math.abs(this.widgetSize.width - width) > 10 ||
                                Math.abs(this.widgetSize.height - height) > 10
                            ) {
                                this.widgetSize = { width, height };
                                // this.forceUpdate();
                            }
                        }}
                    />
                </div>
                <div style={{ position: 'absolute', zIndex: 100, background: '#000', left: 10, bottom: 10 + 48 }}>
                    <ZoomControls />
                </div>
                <div style={{ minHeight: 48, background: 'rgba(0,0,0,0.1)', textAlign: 'right' }}>
                    <Controls style={{ minHeight: 48 }} mainAction={mainAction} />
                </div>
            </div>
        );
    }
}

const PreviewAndVariations = connect(
    ({ editor }) => ({
        preview: editor.preview,
        previewError: editor.previewError,
        autozoom: editor.autozoom,
        zoom: editor.zoom,
    }),
    { setEditorZoom },
)(PreviewAutoZoom);

export default PreviewAndVariations;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/PreviewAndVariations.js
 **/